import { Injectable } from "@angular/core";
import {
    ReplyToUserUsecase,
    ReplyToUserUsecaseInput
} from "@arch/domain/application/usecase/reply-to-user.usecase";
import { ReplyToUserResponse } from "@arch/domain/gateway/data-communication.gateway.interface";

@Injectable({
    providedIn: "root"
})
export class ReplyToUseController {
    constructor(readonly replyToUserUsecase: ReplyToUserUsecase) {}

    public async execute(
        input: ReplyToUserUsecaseInput
    ): Promise<ReplyToUserResponse> {
        const response = await this.replyToUserUsecase.execute(input);
        return response;
    }
}
